import { t } from "@lingui/macro";
import * as React from "react";
import { G, Defs, ClipPath, Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SingleCartIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    title={t`Single Cart`}
    {...props}
    testID="single-cart-icon"
  >
    <G clipPath="url(#a)">
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M11.595 7.676 15 8.432v.892m-3.405-1.648H5.54v-.757h-.757m6.81.757L10.46 2M4.784 6.919h-2.27m2.27 0V3.892m0-1.892h5.676M4.784 2h-.757m.757 0v1.892M10.46 2h1.135M2.514 6.919H1.378L1 12.216h7M2.514 6.92V3.892h2.27"
        fill="none"
      />
      <Circle
        cx={4.027}
        cy={12.216}
        r={1.514}
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <Path
        fill="currentColor"
        d="M13.271 9.66v6.5h-1.177v-5.355h-.038l-1.52.971v-1.08L12.15 9.66h1.12Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
